module.exports = __webpack_public_path__ + "img/fi-organic-breakfast-1200x790.e117757b.jpg";